<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="800px"
  >
    <v-card>
      <v-card-title>
        Conditions générales d'utilisation et de vente
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-8">
        <v-row no-gutters justify="center" align="center" class="py-10" v-if="isFetchingGcu">
          <v-progress-circular indeterminate color="accent" />
        </v-row>
        <div v-html="gcuHtml" v-else />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { marked } from 'marked';
import axios from 'axios';

marked.setOptions({
  gfm: true,
});

export default {
  props: {
    value: Boolean,
  },

  data: () => ({
    isFetchingGcu: false,
    gcuMarkdown: `...`,
  }),

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        return this.$emit(`input`, isOpened);
      },
    },
    gcuHtml() {
      return marked.parse(this.gcuMarkdown);
    },
  },

  methods: {
    async initOpen() {
      try {
        this.isFetchingGcu = true;
        const { data: gcuMarkdown } = await axios.get(`https://raw.githubusercontent.com/nestorr-app/indeego-legal/master/cgu-cgv.md?_=${Date.now()}`);
        this.gcuMarkdown = gcuMarkdown;
        this.isFetchingGcu = false;
      } catch (e) {} // eslint-disable-line
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initOpen();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
